'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg12 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 12, height: 12, viewBox: "0 0 12 12", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.14 1.992a.6.6 0 0 0-.533.32l-.207.387H2a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H7.461l-.122-.319a.6.6 0 0 0-.563-.388z", fill: props.fillColor, fillOpacity: 0.92 }),
    React__namespace.createElement("path", { d: "m2.828 4.849.51 4.363a1.207 1.207 0 0 0 1.198 1.066h2.923c.6 0 1.108-.44 1.194-1.033l.636-4.396M5.1 5.754v2.413m1.81-2.413v2.413", stroke: props.strokeColor, strokeOpacity: 0.92, strokeLinecap: "round" })));

exports.default = Svg12;
//# sourceMappingURL=12.js.map
